import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ToastyModule } from "ng2-toasty";
import {
  IgxGridModule,
  IgxDialogModule,
  IgxFocusModule,
  IgxProgressBarModule,
  IgxCheckboxModule,
  IgxDatePickerModule,
  IgxInputGroupModule,
  IgxComboModule,
  IgxCalendarModule,
  IgxSnackbarModule,
  IgxRippleModule,
  IgxToastModule,
  IgxSwitchModule,
  IgxMaskModule,
  IgxAvatarModule,
  IgxFilterModule,
  IgxNavbarModule,
  IgxDividerModule,
  IgxTabsModule,
  IgxButtonGroupModule,
  IgxTimePickerModule,
  IgxTransactionService,
  IgxCardModule,
  IgxListModule,
  IgxIconModule,
  IgxTooltipModule,
  IgxSelectModule,
  IgxHierarchicalGridModule,
  IgxExcelExporterService,
  IgxCsvExporterService,
} from "igniteui-angular";

import { AlertModule, BreadcrumbModule, ModalModule } from "./components";
import {
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule,
} from "ngx-perfect-scrollbar";
// import {ModalGalleryModule} from '@ks89/angular-modal-gallery';
import { ClickOutsideModule } from "ng-click-outside";
import { SpinnerComponent } from "./components/spinner/spinner.component";
import { CardModule } from "./components/card/card.module";
import { MenuWheelModule } from "./components/menuwheel/menuwheel.module";
import {
  NgbAccordionModule,
  NgbCollapseModule,
  NgbDatepickerModule,
  NgbPopoverModule,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { NgbTabsetModule } from "@ng-bootstrap/ng-bootstrap";
//import { GridWithTransactionsComponent } from '../admin/door-setups/transaction-grid.component';
import { KeyMenuModule } from "./components/key-menu/key-menu.module";
import { AmazingTimePickerModule } from "amazing-time-picker";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { MapComponent } from "./components/map/map.component";
import { GridWithTransactionsComponent } from "./components/transaction-grid/transaction-grid.component";
import { CircularMenuComponent } from "./components/circular-menu/circular-menu.component";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AdminSnackbarComponent } from "../admin/notifications/admin-snackbar/admin-snackbar.component";
import { ContextMenuModule } from "./components/context-menu/context-menu.module";
import { NotFoundModule } from "./components/not-found/not-found.module";

import {
  APP_CONFIG,
  BaseAppConfig,
} from "./components/language-picker/language.config";
import { CookieSettingsComponent } from "./cookie-settings/cookie-settings.component";
import { LoadersModule } from "../loaders/loaders.module";
import { OfflineModalComponent } from "./components/offline-modal/offline-modal.component";
//import { CookieModalComponent } from './cookie-modal/cookie-modal.component';
// import { LoadersModule } from './../../loaders/loaders.module';
import { ProductImagesComponent } from "./components/product-images/product-images.component";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    CommonModule,
    PerfectScrollbarModule,
    FormsModule,
    ReactiveFormsModule,
    BreadcrumbModule,
    LoadersModule,
    // ModalGalleryModule.forRoot(),
    ClickOutsideModule,
    IgxGridModule,
    IgxDialogModule,
    IgxFocusModule,
    IgxProgressBarModule,
    IgxCheckboxModule,
    IgxDatePickerModule,
    IgxInputGroupModule,
    IgxComboModule,
    IgxRippleModule,
    IgxToastModule,
    IgxSwitchModule,
    IgxMaskModule,
    IgxAvatarModule,
    IgxFilterModule,
    IgxNavbarModule,
    IgxHierarchicalGridModule,
    IgxDividerModule,
    IgxTabsModule,
    IgxCalendarModule,
    IgxSnackbarModule,
    IgxButtonGroupModule,
    IgxCardModule,
    IgxTimePickerModule,
    IgxListModule,
    CardModule,
    IgxIconModule,
    IgxTooltipModule,
    IgxSelectModule,
    MenuWheelModule,
    AlertModule,
    ModalModule,
    NgbAccordionModule,
    NgbCollapseModule,
    NgbTabsetModule,
    KeyMenuModule,
    NgxMaterialTimepickerModule,
    NgbPopoverModule,
    NgbTooltipModule,
    IgxTimePickerModule,
    NgbDatepickerModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ContextMenuModule,
    NotFoundModule,
    ToastyModule.forRoot(),
  ],
  exports: [
    CommonModule,
    PerfectScrollbarModule,
    FormsModule,
    ReactiveFormsModule,
    BreadcrumbModule,
    LoadersModule,
    // ModalGalleryModule,
    ClickOutsideModule,
    SpinnerComponent,
    IgxGridModule,
    IgxDialogModule,
    IgxFocusModule,
    IgxProgressBarModule,
    IgxCheckboxModule,
    IgxDatePickerModule,
    IgxInputGroupModule,
    IgxComboModule,
    IgxTimePickerModule,
    IgxRippleModule,
    IgxCalendarModule,
    IgxSnackbarModule,
    IgxToastModule,
    IgxSwitchModule,
    IgxMaskModule,
    IgxAvatarModule,
    IgxFilterModule,
    IgxNavbarModule,
    IgxDividerModule,
    IgxHierarchicalGridModule,
    IgxTabsModule,
    IgxButtonGroupModule,
    IgxCardModule,
    IgxListModule,
    CardModule,
    IgxIconModule,
    IgxTooltipModule,
    IgxSelectModule,
    MenuWheelModule,
    AlertModule,
    ModalModule,
    NgbAccordionModule,
    NgbCollapseModule,
    NgbTabsetModule,
    GridWithTransactionsComponent,
    KeyMenuModule,
    NgxMaterialTimepickerModule,
    CircularMenuComponent,
    // MapComponent
    TranslateModule,
    NgbPopoverModule,
    NgbTooltipModule,
    IgxTimePickerModule,
    NgbDatepickerModule,
    AdminSnackbarComponent,
    ContextMenuModule,
    NotFoundModule,
    ToastyModule,
    ProductImagesComponent,
  ],
  declarations: [
    SpinnerComponent,
    GridWithTransactionsComponent,
    CircularMenuComponent,
    // MapComponent
    AdminSnackbarComponent,
    CookieSettingsComponent,
    ProductImagesComponent,
    // OfflineModalComponent,
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    { provide: APP_CONFIG, useValue: BaseAppConfig },
  ],
})
export class SharedModule {}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
